module.exports = __webpack_public_path__ + "img/bg_13.3153ff96.png";